import { useState } from "react";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { CareSettings } from "@/components/site/CareSettings";
import { Services } from "@/components/site/Services";
import { Roles } from "@/components/site/Roles";
import { Checklist } from "@/components/site/Checklist";
import { ApplicationSection } from "@/components/application/ApplicationSection";
import { Faq } from "@/components/site/Faq";
import { RequestForms } from "@/components/site/RequestForms";
import { About } from "@/components/site/About";
import { Privacy } from "@/components/site/Privacy";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/chat/ChatWidget";
import { MobileActionBar } from "@/components/site/MobileActionBar";

export default function Home() {
  const [chatOpen, setChatOpen] = useState(false);
  return (
    <div className="bg-[#FBF8F1] text-[#1A2E2B] font-sans pb-[calc(76px+env(safe-area-inset-bottom))] lg:pb-0">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <SmoothScroll />
      <Header onOpenChat={() => setChatOpen(true)} />
      <main id="main-content">
        <Hero />
        <Marquee />
        <CareSettings />
        <About />
        <Services />
        <RequestForms />
        <Roles />
        <Checklist />
        <ApplicationSection />
        <Faq />
        <Privacy />
        <Contact />
      </main>
      <Footer />
      <ChatWidget open={chatOpen} setOpen={setChatOpen} />
      {!chatOpen && <MobileActionBar onOpenChat={() => setChatOpen(true)} />}
    </div>
  );
}
